import { useState } from 'react';

import { format as formatDate, addMonths, subMonths } from 'date-fns';
import { ru } from 'date-fns/locale';
import { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader';
import IconButton from '@mui/material/IconButton';
import Fade from '@mui/material/Fade';

import { Box } from '../../Box';
import { Typography } from '../../Typography';
import { Icon } from '../../Icon';

import useStyles from './CalendarHeader.styles';

/**
 * Компонент для отображения заголовка календаря.
 *
 * @public
 * @param currentMonth - Дата отображаемого месяца.
 * @param onMonthChange - Функция для переключения месяца.
 * @returns  Возвращает JSX-элемент представляющий компонент CalendarHeader.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link CalendarHeader}
 */
export const CalendarHeader = ({
  currentMonth,
  onMonthChange,
}: PickersCalendarHeaderProps<Date>) => {
  const { classes } = useStyles();

  const [isFading, setIsFading] = useState(false);

  const selectNextMonth = () => {
    setIsFading(true);
    onMonthChange(addMonths(currentMonth, 1), 'left');
    setTimeout(() => {
      setIsFading(false);
    }, 200);
  };

  const selectPreviousMonth = () => {
    setIsFading(true);
    onMonthChange(subMonths(currentMonth, 1), 'right');
    setTimeout(() => {
      setIsFading(false);
    }, 200);
  };

  return (
    <div className={classes.switchHeader}>
      <IconButton
        className={classes.iconButton}
        onClick={selectPreviousMonth}
        title="Предыдущий месяц"
      >
        <Box
          width={24}
          height={24}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon name="chevron_left" size="16" />
        </Box>
      </IconButton>
      <div className={classes.fadeContainer}>
        <Fade
          in={!isFading}
          timeout={200}
          easing={{ enter: 'cubic-bezier(0.1, 1, 0.6, 1)' }}
        >
          <Box width="fit-content">
            <Typography variant="body2" className={classes.lable}>
              {formatDate(currentMonth, 'LLLL yyyy', { locale: ru })}
            </Typography>
          </Box>
        </Fade>
      </div>
      <IconButton
        className={classes.iconButton}
        onClick={selectNextMonth}
        title="Следующий месяц"
      >
        <Box
          width={24}
          height={24}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon name="chevron_right" size="16" />
        </Box>
      </IconButton>
    </div>
  );
};
